import React, { memo, useCallback } from 'react';
import classNames from 'classnames';

import style from './style.module.css';

const ButtonComponent = ({ children, value, label, isActive, shape, size, onSelect }) => {
  const handleClick = useCallback(() => onSelect(value), [onSelect, value]);

  const className = classNames('btn btn-sm', style.button, {
    'btn-primary': isActive,
    'btn-default': !isActive,
    [style.rounded]: shape === 'rounded',
    [style.small]: size === 'small',
  });

  return (
    <button className={className} onClick={handleClick} type="button">
      {label ?? children}
    </button>
  );
};

export const Button = memo(ButtonComponent);
